/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AppSecopsPortfolioFilter extends models.AppSecopsFilterBase {
    getFixupPrototypeFunction() { return AppSecopsPortfolioFilter.fixupPrototype; }

    static newInstance(model: Partial<AppSecopsPortfolioFilter>): AppSecopsPortfolioFilter {
        let obj = Object.assign(new AppSecopsPortfolioFilter(), model);
        AppSecopsPortfolioFilter.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AppSecopsPortfolioFilter>): AppSecopsPortfolioFilter {
        if (!model) return null;
        return AppSecopsPortfolioFilter.newInstance(<AppSecopsPortfolioFilter> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AppSecopsPortfolioFilter) {
        if (!obj) return;

        models.AppSecopsPortfolioFilter.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AppSecopsPortfolioFilter): boolean {
        if (models.AppSecopsFilterBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AppSecopsPortfolioFilter.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Owner of the Portfolio
     */
    owner: Array<string>;

    /**
     * Search based on name, description, owner
     */
    search: string;

}
